import TextInput from '../../../../lib/TextField';
import { ProfileEvent, useProfileInfo } from './profile-context';
import { Grid, Typography } from '@material-ui/core';

export const InvestorName = () => {
    const { state: profileState, dispatch: profileDispatch } = useProfileInfo();
    return (
        <>
            <Grid container spacing={1} alignItems="flex-start">
                <Grid item xs={12} md={6} style={{ textAlign: 'left' }}>
                    <Grid item xs={12} md={4}>
                        <Typography
                            style={{
                                marginLeft: '8px',
                                marginBottom: '10px',
                                marginTop: '10px',
                                fontSize: 15,
                                color: '#7a6de8',
                            }}
                        >
                            Name of the Investor
                        </Typography>
                    </Grid>
                    <Grid container alignItems="center">
                        <Grid item xs={10} md={8}>
                            <TextInput
                                fullWidth
                                className="filled-input-inactive"
                                variant="filled"
                                value={profileState.investorName}
                                onChange={(e) =>
                                    profileDispatch({
                                        action: ProfileEvent.SetInvestorName,
                                        payload: e.target.value,
                                    })
                                }
                                error={!!profileState.errors.investorName && profileState.submitted}
                                helperText={
                                    profileState.submitted && profileState.errors.investorName
                                }
                                label="Please enter Investor's Name"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};
